import { createContext, useContext } from 'react';

import { DropdownMenuItem } from '../dropdown';

export interface ContextMenuOptions {
  position: { x: number; y: number };
  items: DropdownMenuItem[];
  onOpen?: () => void;
  onClose?: () => void;
}

export const ContextMenuContext = createContext({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  openContextMenu: (menu: ContextMenuOptions) => {},
});

export const useContextMenu = () => useContext(ContextMenuContext);
